define('eureka_maxapartpicker_header.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('eureka_maxapartpicker_header', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true}, 'extensions/Eureka/MaxaPartPicker/1.1.0/', 'extensions/Eureka/MaxaPartPicker/1.1.0/', Handlebars);
});